import { render, staticRenderFns } from "./relayLogs.vue?vue&type=template&id=a3bf0622&"
import script from "./relayLogs.vue?vue&type=script&lang=ts&"
export * from "./relayLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports